module.exports = __webpack_public_path__ + "img/logo.13967d40.png";